const translations = {
  title: 'Histórico de gatilhos disparados',
  name: 'Nome',
  status: 'Status',
  originEntity: 'Entidade de origem',
  destinationEntity: 'Entidade destino',
  date: 'Data',
  idLabel: 'ID: {{id}}',
  triggerFired: 'Gatilho disparado',
  cardsViewComingSoon: 'Visão de cards (em breve)',
  seeDetails: 'Ver detalhes',
  runManually: 'Rodar manualmente',
  confirmRetry: 'Certeza que deseja executar novamente?',
  'tabs.result': 'Resultado',
  'tabs.payload': 'Payload',
  'tabs.entity': 'Entidade',
  'tabs.trigger': 'Gatilho',
  'tabs.rest': 'Resto'
}

export default translations
